import * as React from 'react'
import { useDispatch } from 'react-redux'

import {
  submitDraft,
  setProductOfDraft,
  setUpgradesOfDraft,
} from '../../../state/actions/draft/draft'
import type { State } from '../../../state/reducers'
import type {
  JobPostingProduct,
  ProductUpgrade,
} from '../../../state/reducers/entitlement/entitlement'

export type SubmitDraftType = {
  draftId: string
  product: JobPostingProduct
  upgrades: ProductUpgrade[]
}

/**
 * Push product and upgrades to Redux store and submit current draft
 */
export const useSubmitDraft = () => {
  const dispatch = useDispatch()

  return React.useCallback(({ draftId, product, upgrades }: SubmitDraftType) => {
    // Draft state is used on the next page
    dispatch(setProductOfDraft(product))
    dispatch(setUpgradesOfDraft(upgrades))

    // Submit draft to backend
    dispatch(
      submitDraft({
        id: draftId,
        product,
        upgrades,
      }),
    )
  }, [])
}
